import { Socket } from 'rete'

export const layerSocket = new Socket('Layer')
export const setSocket = new Socket('Set')
export const mapSocket = new Socket('Map')
